export const FEED_CREATED = 1;
export const MANUAL_CREATED = 2;
export const SORT_ORDER_CREATE = 1;
export const SORT_ORDER_LINK = 2;
export const UNIVERSAL_REGISTRY_RETAILER_ID = 20000;
export const CATALOG_REGISTRY_RETAILER_ID = 30000;
export const MANAGE_REGISTRY_CLICK_SOURCE_ID =
  '6434B0C3-51AA-4464-8E2C-242B1725AA03';
